<template>
  <div class="select-bar">
    <div class="select-bar-label">{{ $t("product.classify") }}：</div>

    <div class="select-bar-con">
      <el-select
        v-model="ID_1"
        :placeholder="$t('other.choose')"
        :no-data-text="$t('product.noDataText')"
        @change="onClassify1Change"
      >
        <el-option
          v-for="item in classify_1"
          :key="item.ID"
          :label="item[getName()]"
          :value="item.ID"
        >
          <span>{{ item[getName()] }}</span>
        </el-option>
      </el-select>

      <el-select
        v-model="ID_2"
        :placeholder="$t('other.choose')"
        :no-data-text="$t('product.noDataText')"
        @change="onClassify2Change"
      >
        <el-option
          v-for="item in classify_2"
          :key="item.ID"
          :label="item[getName()]"
          :value="item.ID"
        >
          <span>{{ item[getName()] }}</span>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: ["classify_1", "classify_1_ID", "classify_2"],
  data() {
    return {
      ID_1: "",
      ID_2: ""
    };
  },
  mounted() {},
  methods: {
    // 获取当前使用名称
    getName() {
      let name = "";

      switch (this.$i18n.locale) {
        case "zh":
          name = "ItemName";
          break;
        case "en":
          name = "EnglishName";
          break;
        case "sp":
          name = "xibanyaName";
          break;
      }

      return name;
    },
    onClassify1Change(e) {
      this.$emit("onClassifySelect", {
        level: 1,
        ID: e
      });
    },
    onClassify2Change(e) {
      this.$emit("onClassifySelect", {
        level: 2,
        ID: e
      });
    }
  },
  watch: {
    classify_1: {
      handler(val) {
        if (val && val.length > 0) {
          this.ID_1 = val[0].ID;
        }
      },
      immediate: true,
      deep: true
    },
    classify_1_ID(val) {
      this.ID_1 = val;
      this.ID_2 = "";
    }
  }
};
</script>

<style lang="less">
.select-bar {
  display: flex;
  align-items: center;
  padding: 10px 0;

  .select-bar-label {
    font-size: 16px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #000;
  }

  .select-bar-con {
    flex: 1;
    display: flex;
    align-items: center;

    .el-select {
      flex: 1;
      margin-left: 30px;

      .el-input__inner {
        background: #ebf9ff;
      }
    }
  }
}
</style>
